// Este import vem PRIMEIRO de propósito, e trocar a ordem devolve um defeito:
// quem apaga o hash da URL é o cliente do Supabase, e é do hash que
// linkDeEmail lê o tipo do link. Módulos ES são avaliados na ordem dos imports,
// então esta linha garante a captura antes de `createClient`.
import "./linkDeEmail";
import { createClient } from "@supabase/supabase-js";
import { fetchDoVerComo, instalarVerComo, sessaoVerComo } from "./verComo";

// A anon key é pública por desenho: ela vai no bundle que qualquer navegador
// baixa. Quem protege o dado é a RLS da 000002 (anon não lê nada; authenticated
// lê só as linhas do próprio aluno), provada pelo teste 21. A service_role key
// NUNCA entra aqui — ela ignora RLS.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  throw new Error("Configure app/.env — o modelo está em app/.env.example");
}

// O «ver como» do master (000335). Fora dele o cliente é o de sempre, sem
// `fetch` próprio: a troca só existe na aba que tem uma sessão, e entrar e sair
// recarregam a página — então este `if` decide o cliente da página inteira.
instalarVerComo();
export const supabase = createClient(
  url,
  anon,
  sessaoVerComo() ? { global: { fetch: fetchDoVerComo } } : undefined,
);
